function productcarousel(){
  var productslider=[];
  document.querySelectorAll('.product-carousel').forEach(function(Element,index){
    let productid = Element.dataset.id;
    let outer_carousel = Element.closest('.carousel-rowouter');
    let nextbutton = outer_carousel.querySelector('.next-btn');
    let prevbutton = outer_carousel.querySelector('.prev-btn');
    let swiperObject={
      loop:eval(Element.dataset.loop),
      slidesPerView: "auto",
      navigation: {
        nextEl:nextbutton,
        prevEl:prevbutton,
      },
    };    
    productslider[productid]=new Swiper(Element,swiperObject);
  });
}
productcarousel();